<mat-card appearance="outlined">
    <ng-container [ngSwitch]="inputType">
        <!-- DATE EDITOR -->
        <ng-container *ngSwitchCase="'DATE'">
            <form tabindex="0" class="fix-editor">
                <mat-form-field class="ag-row fix-mat-form"
                                [style.width]="width">
                    <input #dateInput matInput tabindex="0"
                           [formControl]="formControl"
                           [errorStateMatcher]="matcher"
                           [matDatepicker]="picker"
                           (keydown.space)="_onSpaceBar($event)">
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker
                                    panelClass="ag-custom-component-popup se-ui-dateTimePickerEditor">
                    </mat-datepicker>
                    <mat-error *ngIf="formControl.hasError('required')">
                        {{ 'se-ui-datagrid_required_value_constraint' | translate }}
                    </mat-error>
                </mat-form-field>
                <mat-calendar class="se-ui-dateTimePickerEditor"
                              [selected]="setDateValue()"
                              (selectedChange)="updateDate($event)">
                </mat-calendar>
            </form>
        </ng-container>

        <!-- TIME EDITOR -->
        <ng-container *ngSwitchCase="'TIME'">
            <se-time-picker #seTimePicker class="cp-input" tabindex="0"
                            [timeFormat]="timeInputFormat"
                            [isWithLabel]="false"
                            [showIcon]="false"
                            [showResetButton]="false"
                            [required]="required"
                            [time]="value"
                            (timeChange)="_updateModel($event)"
                            (timePickerKeyDown)="_onTimePickerKeydown($event)">
            </se-time-picker>
        </ng-container>
    </ng-container>
</mat-card>
